<div class="logo-container">
  <img [src]="museum_logo || 'assets/img/museum-logo.png'" class="img-fluid"
       [attr.alt]="'about-us-page.museum-logo' | translate | titlecase">
</div>
